export default {
  title: 'Account Information',
  emailLoginId: 'email/login ID',
  password: 'Password',
  changeEmail: 'Change Email',
  changePassword: 'Change Password'
}
